import Skeleton from "@mui/material/Skeleton";

function TopServicesSkeleton() {
  return (
    <Skeleton className="rounded-2xl" variant="rectangular" height={390} />
  );
}

export default TopServicesSkeleton;
